module.exports = ".modal-body {\n  overflow-y: auto;\n  overflow-x: auto;\n  max-height: 80vh; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administration/basic-process-configuration/manage-function/manage-function.component.scss
// module id = ./src/app/administration/basic-process-configuration/manage-function/manage-function.component.scss
// module chunks = main